// Constants TypeScript files should be AUTO-GENERATED by the Typewriter Visual Studio plugin. Do not modify this file.
enum DeviceConnectionState {
    Disconnected = 'Disconnected',
    Connected = 'Connected',
}
export default DeviceConnectionState;
